import { render } from "./car0.vue?vue&type=template&id=0d5ce927&scoped=true"
const script = {}

import "./car0.vue?vue&type=style&index=0&id=0d5ce927&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5ce927"]])

export default __exports__